const getAcceptLanguage = (locale) => {
    const isCSE = window.location.href.includes("cse")
    if(isCSE) {
        return "fr_FR_CSE"
    }

    return locale || 'fr-FR'
}


const getHeaders = (options = {}) => {
	
	
	const {locale, headers = {}} = options;

	const providedLocale = locale || $('html').attr('lang') || 'fr-FR'

	return {
		'Accept-Language': getAcceptLanguage(providedLocale),
		...headers,
	}
}
export default getHeaders;